import { Icon, Menu, MenuButton, MenuItem, MenuList, Typography } from '@aloft/toolkit-sui';

export const ValuationTablePropertyHeaderMenu = ({
  openDeleteConfirmationModal,
  openEditPropertyDetailsModal,
  isRemovable,
}: {
  openDeleteConfirmationModal: () => void;
  openEditPropertyDetailsModal: () => void;
  isRemovable: boolean;
}) => (
  <Menu placement="bottom-end">
    <MenuButton paddingTop="4px">
      <Icon icon="more-2" size="md" color="textSecondary" />
    </MenuButton>
    <MenuList minWidth="100px">
      {isRemovable && (
        <MenuItem onClick={openDeleteConfirmationModal} width="150px">
          <Typography>Delete</Typography>
        </MenuItem>
      )}
      <MenuItem onClick={openEditPropertyDetailsModal} width="150px">
        <Typography>Edit Details</Typography>
      </MenuItem>
    </MenuList>
  </Menu>
);
